

    <form [formGroup]="accountGroupForm">
      <!-- <div class="formgrid grid"> -->
        <!-- Save Button -->
        <div class="field col-12 flex justify-content-between align-items-center"> 
          <div>
            <p-button label="Save" class="p-button-outlined ml-2" icon="pi pi-save" size="small"
              (click)="createAccountGroup()"></p-button>
          </div>

          <div>
                <label class="block label-required" style="font-weight: bold;">Required Field</label>
            </div>
        </div>
        <div class="formgrid grid">
        <!-- Account Group Code Field -->
         <div>
        <div class="col">
          <div class="field text-left" style="display: flex; flex-direction: column; align-items: flex-start;">
            <label for="website" class="label-required display">Account Group Code</label>
            <div style="display: flex; align-items: center;">
              <input type="text" pInputText placeholder="e.g AG89098" (blur)="checkAccountGroupCode()" class="w-full"
                formControlName="AccountGroupCode" [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.AccountGroupCode.errors }" />
              <div style="margin-left: 10px;">
                <p-checkbox formControlName="manualEntry" (onChange)="manualEntry()" [binary]="true"
                  label="Manual Entry" value="true"></p-checkbox>
              </div>
            </div>
            <small *ngIf="submitted && formControls.AccountGroupCode.errors" class="text-red-500">Required field.</small>
          </div>
        </div><br>
      
        <!-- Account Group Name Field -->
        <div class="col">
          <div class="field text-left">
            <label for="website" class="label-required display">Account Group Name</label>
            <input pInputText placeholder="e.g Tom Hank" class="w-full"
              formControlName="AccountGroupName" [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.AccountGroupName.errors }" />
            <small *ngIf="submitted && formControls.AccountGroupName.errors" class="text-red-500">Required field.</small>
          </div>
        </div></div>
  <div>

    <!-- Account Type Field -->
    <div class="col">
      <div class="field text-left">
        <label for="website" class="label-required display">Account Type </label> 
        <p-autoComplete 
        formControlName="accountType" [dropdown]="true" 
        (onSelect)="setUOM($event)"  
        [suggestions]="filteruom"
        (completeMethod)="filterUOM($event)"
        field="accountType"
        placeholder="Search account types"
        class="w-full mb-3 large-textbox"
        styleClass="w-full mb-3" 
        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.accountType.errors }">
        <ng-template let-item pTemplate="item">
            <span><span class="text-primary">{{item.accountTypeCode}}</span> - {{item.accountType}}</span>
        </ng-template>
    </p-autoComplete>
          <small *ngIf="submitted && formControls.accountType.errors" class="text-red-500" style="margin-top: -10px; display: block;">Required field.</small>
      </div>
    </div>
        <!-- Account Group Description Field -->
        <div class="col">
          <div class="field text-left">
            <label for="website">Account Group Description</label>
            <input pInputText class="w-full" formControlName="AccountGroupDescription" />
          </div>
        </div>

      </div></div><br>
    </form>

